// Import assets
import icadLogo from '../assets/techs/icad.jpg';
import legitLogo from '../assets/techs/LH-Logo.png';
import canaryLogo from '../assets/techs/CS-logo.png';
import medicusLogo from '../assets/techs/medicus.jpg';
import neuralLogo from '../assets/techs/TheNeuralLogo.jpeg';

export const productsTranslations = {
    es: {
        categories: {
            Todos: "Todos",
            Imagenologia: "Imagenología",
            Dermatologia: "Dermatología",
            Cardiologia: "Cardiología",
            "Salud Mental": "Salud Mental",
            "Laboratorio Clinico": "Laboratorio Clínico"
        },
        items: [
            {
                id: 4,
                name: "Legit.Health",
                category: "Dermatologia",
                description: "IA aplicada a la dermatología clínica que asiste en el diagnóstico y seguimiento de más de 300 patologías cutáneas.",
                tag: "Dermatología",
                logo: legitLogo,
                stats: ["Marcado CE", "Follow-up Auto"]
            },
            {
                id: 5,
                name: "US2AI",
                category: "Cardiologia",
                description: "Automatización completa del flujo de ecocardiografía con análisis de IA que reduce el tiempo de reporte a minutos.",
                tag: "Cardio Echo",
                logo: "https://lh3.googleusercontent.com/aida-public/AB6AXuD3b8Teml7hApGLnXt7WCW2ROdZl9NLLw5JnfHPxaSArhEE3HItCilMd696sQM0p1B5h1A3XgEKPFjB95wlwM2WR_llXU2R1MsANdFymSNkNYYbG4uB_0jF4HCnGZD-xqU3KGwAXFQRCNk_YczaozGWJs9Ex-aXUPwDXrfVLJ8vrRuz1ciZF7asJzwYB82yv-zdPPW97Ro5Stmdy_eXPC3mSS4HC66Vbu9TJe4BzFl6v2LaqWPbrlwAqbmGxR3fgYPXK4skJxDCwac",
                stats: ["Auto-EF", "Full Reporting"]
            },
            {
                id: 6,
                name: "TheNeuralCloud",
                category: "Cardiologia",
                description: "Plataforma de IA nativa en la nube para procesamiento avanzado de imágenes cardiovasculares y soporte diagnóstico.",
                tag: "Cardiac AI",
                logo: neuralLogo,
                stats: ["Cloud Native", "Trazabilidad"]
            },
            {
                id: 7,
                name: "Cannary Speech",
                category: "Salud Mental",
                description: "Análisis de biomarcadores de voz para detectar estrés, ansiedad y deterioro cognitivo de forma no invasiva.",
                tag: "Neuro-Acoustic",
                logo: canaryLogo,
                stats: ["Non-Invasive", "Voice Markers"]
            },
            {
                id: 8,
                name: "Medicus.AI",
                category: "Laboratorio Clinico",
                description: "Plataforma que transforma datos de laboratorio en reportes visuales con insights procesables para el paciente.",
                tag: "Labs & Wellness",
                logo: medicusLogo,
                stats: ["Lab Integration", "Visual Insights"]
            },
            {
                id: 9,
                name: "DeepC",
                category: "Imagenologia",
                description: "Marketplace de IA para imágenes médicas, con soluciones para radiología.",
                tag: "Marketplace",
                logo: medicusLogo,
                stats: ["Marketplace", "AI Solutions"]
            },
            {
                id: 10,
                name: "Deep Health",
                category: "Imagenologia",
                description: "Marketplace de IA para imágenes médicas, con soluciones para radiología.",
                tag: "Marketplace",
                logo: medicusLogo,
                stats: ["Marketplace", "AI Solutions"]
            },
            {
                id: 11,
                name: "Azmed",
                category: "Imagenologia",
                description: "Soluciones para Fracturas, Torax y Mediciones de Cadera.",
                tag: "Fracturas",
                logo: medicusLogo,
                stats: ["Fracturas", "Torax"]
            },
            {
                id: 12,
                name: "Cortechs.ai",
                category: "Imagenologia",
                description: "Soluciones para Placeholders.",
                tag: "Placeholders",
                logo: medicusLogo,
                stats: ["Placeholders", "Placeholders"]
            },
            {
                id: 13,
                name: "Avicena.ai",
                category: "Imagenologia",
                description: "Soluciones para Placeholders.",
                tag: "Placeholders",
                logo: icadLogo,
                stats: ["Placeholders", "Placeholders"]
            },
        ]
    },
    en: {
        categories: {
            Todos: "All",
            Imagenologia: "Imaging",
            Dermatologia: "Dermatology",
            Cardiologia: "Cardiology",
            "Salud Mental": "Mental Health",
            "Laboratorio Clinico": "Clinical Laboratory"
        },
        items: [
            {
                id: 4,
                name: "Legit.Health",
                category: "Dermatologia",
                description: "AI applied to clinical dermatology assisting in the diagnosis and follow-up of over 300 skin conditions.",
                tag: "Dermatology",
                logo: legitLogo,
                stats: ["CE Marked", "Auto Follow-up"]
            },
            {
                id: 5,
                name: "US2AI",
                category: "Cardiologia",
                description: "Complete echocardiography workflow automation with AI analysis that reduces reporting time to minutes.",
                tag: "Cardio Echo",
                logo: "https://lh3.googleusercontent.com/aida-public/AB6AXuD3b8Teml7hApGLnXt7WCW2ROdZl9NLLw5JnfHPxaSArhEE3HItCilMd696sQM0p1B5h1A3XgEKPFjB95wlwM2WR_llXU2R1MsANdFymSNkNYYbG4uB_0jF4HCnGZD-xqU3KGwAXFQRCNk_YczaozGWJs9Ex-aXUPwDXrfVLJ8vrRuz1ciZF7asJzwYB82yv-zdPPW97Ro5Stmdy_eXPC3mSS4HC66Vbu9TJe4BzFl6v2LaqWPbrlwAqbmGxR3fgYPXK4skJxDCwac",
                stats: ["Auto-EF", "Full Reporting"]
            },
            {
                id: 6,
                name: "TheNeuralCloud",
                category: "Cardiologia",
                description: "Cloud-native AI platform for advanced cardiovascular imaging processing and diagnostic support.",
                tag: "Cardiac AI",
                logo: neuralLogo,
                stats: ["Cloud Native", "Traceability"]
            },
            {
                id: 7,
                name: "Cannary Speech",
                category: "Salud Mental",
                description: "Analysis of voice biomarkers to non-invasively detect stress, anxiety, and cognitive decline.",
                tag: "Neuro-Acoustic",
                logo: canaryLogo,
                stats: ["Non-Invasive", "Voice Markers"]
            },
            {
                id: 8,
                name: "Medicus.AI",
                category: "Laboratorio Clinico",
                description: "Platform that transforms laboratory data into visual reports with actionable insights for the patient.",
                tag: "Labs & Wellness",
                logo: medicusLogo,
                stats: ["Lab Integration", "Visual Insights"]
            },
            {
                id: 9,
                name: "DeepC",
                category: "Imagenologia",
                description: "Marketplace de IA para imágenes médicas, con soluciones para radiología.",
                tag: "Marketplace",
                logo: medicusLogo,
                stats: ["Marketplace", "AI Solutions"]
            },
            {
                id: 10,
                name: "Deep Health",
                category: "Imagenologia",
                description: "Marketplace de IA para imágenes médicas, con soluciones para radiología.",
                tag: "Marketplace",
                logo: medicusLogo,
                stats: ["Marketplace", "AI Solutions"]
            },
            {
                id: 11,
                name: "Azmed",
                category: "Imagenologia",
                description: "Soluciones para Fracturas, Torax y Mediciones de Cadera.",
                tag: "Fracturas",
                logo: medicusLogo,
                stats: ["Fracturas", "Torax"]
            },
            {
                id: 12,
                name: "Cortechs.ai",
                category: "Imagenologia",
                description: "Soluciones para Placeholders.",
                tag: "Placeholders",
                logo: medicusLogo,
                stats: ["Placeholders", "Placeholders"]
            },
            {
                id: 13,
                name: "Avicena.ai",
                category: "Imagenologia",
                description: "Soluciones para Placeholders.",
                tag: "Placeholders",
                logo: medicusLogo,
                stats: ["Placeholders", "Placeholders"]
            }
        ]
    }
};
